import { render, staticRenderFns } from "./ProzessSelect.vue?vue&type=template&id=062ec8ce"
import script from "./ProzessSelect.vue?vue&type=script&lang=js"
export * from "./ProzessSelect.vue?vue&type=script&lang=js"
import style0 from "./ProzessSelect.vue?vue&type=style&index=0&id=062ec8ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports